// extracted by mini-css-extract-plugin
export default {"container":"TaxTemplateEditor_container__B9kzm","header_container":"TaxTemplateEditor_header_container__xAu4-","content_container":"TaxTemplateEditor_content_container__YmnF3"};